// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html, body {
    height: 100%;
    font-family: Arial, sans-serif;
    background-color: #F1F4F8; /* Light blue background */
}

.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* Full screen height */
}

.login-form {
    background-color: #ffffff; /* White background for form */
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Shadow */
    text-align: center;
    width: 100%;
    max-width: 400px;
}

.login-form h2 {
    margin-bottom: 20px;
    font-size: 24px;
    color: #000000; /* Dark green heading color */
}

.input-field {
    width: 100%;
    padding: 12px;
    margin: 10px 0;
    border-radius: 8px; /* Rounded corners */
    border: 1px solid #ccc;
    outline: none;
    font-size: 16px;
}

.input-field:focus {
    border-color: #007bff; /* Blue border on focus */
}

/* Error text styling */
.error-text {
    color: red;
    font-size: 14px;
    margin: 10px 0;
}

/* Error border for input fields */
.error-border {
    border-color: red !important; /* Red border on error */
}

.submit-btn {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: none;
    background-color: #FF0000; /* Red background for button */
    color: white;
    font-size: 16px;
    cursor: pointer;
    margin-top: 20px;
}

.submit-btn:hover {
    background-color: #cc0000; /* Darker red on hover */
}
`, "",{"version":3,"sources":["webpack://./src/style/LoginForm.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,yBAAyB,EAAE,0BAA0B;AACzD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,uBAAuB;AAC1C;;AAEA;IACI,yBAAyB,EAAE,8BAA8B;IACzD,aAAa;IACb,kBAAkB;IAClB,wCAAwC,EAAE,WAAW;IACrD,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc,EAAE,6BAA6B;AACjD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB,EAAE,oBAAoB;IACxC,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,qBAAqB,EAAE,yBAAyB;AACpD;;AAEA,uBAAuB;AACvB;IACI,UAAU;IACV,eAAe;IACf,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI,4BAA4B,EAAE,wBAAwB;AAC1D;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,yBAAyB,EAAE,8BAA8B;IACzD,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB,EAAE,wBAAwB;AACvD","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nhtml, body {\n    height: 100%;\n    font-family: Arial, sans-serif;\n    background-color: #F1F4F8; /* Light blue background */\n}\n\n.login-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh; /* Full screen height */\n}\n\n.login-form {\n    background-color: #ffffff; /* White background for form */\n    padding: 40px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Shadow */\n    text-align: center;\n    width: 100%;\n    max-width: 400px;\n}\n\n.login-form h2 {\n    margin-bottom: 20px;\n    font-size: 24px;\n    color: #000000; /* Dark green heading color */\n}\n\n.input-field {\n    width: 100%;\n    padding: 12px;\n    margin: 10px 0;\n    border-radius: 8px; /* Rounded corners */\n    border: 1px solid #ccc;\n    outline: none;\n    font-size: 16px;\n}\n\n.input-field:focus {\n    border-color: #007bff; /* Blue border on focus */\n}\n\n/* Error text styling */\n.error-text {\n    color: red;\n    font-size: 14px;\n    margin: 10px 0;\n}\n\n/* Error border for input fields */\n.error-border {\n    border-color: red !important; /* Red border on error */\n}\n\n.submit-btn {\n    width: 100%;\n    padding: 12px;\n    border-radius: 8px;\n    border: none;\n    background-color: #FF0000; /* Red background for button */\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n    margin-top: 20px;\n}\n\n.submit-btn:hover {\n    background-color: #cc0000; /* Darker red on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
